import { TypedJSONObject } from '../types';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import {
  QueryTemplateCategoriesArgs,
  QueryTemplateGalleryArgs,
} from '../generated';
import { clientVersion } from '@trello/config';

export const templateCategoriesResolver = async (
  _parent: unknown,
  args: QueryTemplateCategoriesArgs,
  _context: unknown,
  info: QueryInfo,
): Promise<TypedJSONObject> => {
  let model = null;

  const apiUrl = `/1/resources/templates/categories?locale=${
    args.locale || 'en'
  }`;

  let response;

  try {
    response = await fetch(apiUrl, {
      credentials: 'include',
      headers: {
        'X-Trello-Client-Version': clientVersion,
      },
    });

    if (response.ok) {
      model = await response.json();
      return model ? prepareDataForApolloCache(model, info) : model;
    }
  } catch (err) {
    console.error(err);
    throw new Error(
      `An error occurred while fetching/parsing template categories GraphQL query. ${{
        error: err,
        response,
      }}`,
    );
  }

  throw new Error(
    `An error occurred while resolving template categories GraphQL query. (status: ${response?.status}, statusText: ${response?.statusText})`,
  );
};

export const templateLanguagesResolver = async (
  _parent: unknown,
  _args: unknown,
  _context: unknown,
  info: QueryInfo,
): Promise<TypedJSONObject> => {
  let model = null;

  const apiUrl = '/1/resources/templates/languages?enabled=true';

  let response;

  try {
    response = await fetch(apiUrl, {
      credentials: 'include',
      headers: {
        'X-Trello-Client-Version': clientVersion,
      },
    });

    if (response.ok) {
      model = await response.json();
      return model ? prepareDataForApolloCache(model, info) : model;
    }
  } catch (err) {
    console.error(err);
    throw new Error(
      `An error occurred while fetching/parsing template languages GraphQL query. ${{
        error: err,
        response,
      }}`,
    );
  }

  throw new Error(
    `An error occurred while resolving template languages GraphQL query. (status: ${response?.status}, statusText: ${response?.statusText})`,
  );
};

export const templateGalleryResolver = async (
  _parent: unknown,
  args: QueryTemplateGalleryArgs,
  _context: unknown,
  info: QueryInfo,
): Promise<TypedJSONObject> => {
  let model = null;

  const apiUrl = `/1/boards/templates/gallery?locale=${args.locale || 'en'}`;

  let response;

  try {
    response = await fetch(apiUrl, {
      credentials: 'include',
      headers: {
        'X-Trello-Client-Version': clientVersion,
      },
    });

    if (response.ok) {
      model = await response.json();
      return model ? prepareDataForApolloCache(model, info) : model;
    }
  } catch (err) {
    console.error(err);
    throw new Error(
      `An error occurred while fetching/parsing template gallery GraphQL query. ${{
        error: err,
        response,
      }}`,
    );
  }

  throw new Error(
    `An error occurred while resolving template gallery GraphQL query. (status: ${response?.status}, statusText: ${response?.statusText})`,
  );
};
